exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".img-preview img{max-width:100%}", "", {"version":3,"sources":["/./src/components/img-uploader/img-uploader.vue"],"names":[],"mappings":"AACA,iBACE,cAAgB,CACjB","file":"img-uploader.vue","sourcesContent":["\n.img-preview img{\n  max-width: 100%;\n}\n"],"sourceRoot":"webpack://"}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?sourceMap!./~/vue-loader/lib/style-rewriter.js?id=data-v-2c8a79f5!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/img-uploader/img-uploader.vue
// module id = 172
// module chunks = 17